import { render, staticRenderFns } from "./AppWithLogo.vue?vue&type=template&id=7f5649cf"
import script from "./AppWithLogo.vue?vue&type=script&lang=js"
export * from "./AppWithLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports